import React from 'react';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { styled } from '@cp/ds/src/theme';

const Root = styled(Box, { name: 'Error' })({
  fontFamily: 'monospace',
  fontSize: '.9rem',
  padding: '5px',
  '& summary': {
    marginBlockEnd: '1rem',
  },
});

export interface ErrorRenderProps extends BoxProps {
  error: Error;
}
export const ErrorRender: React.FC<ErrorRenderProps> = ({ error, ...props }) => {
  return (
    <Root {...props}>
      <details>
        <summary>{error.message}</summary>
        <code>{error.stack}</code>
      </details>
    </Root>
  );
};
